import { debounce } from 'lodash';

import { getQueryClient } from '@/context/ReactQueryProvider';
import { clearSnapWalletInventoryCache } from '@/lib/snap-wallet-reader';

import { QueryKeys } from './api/query-keys';

// V3
// Vault queries:
// - useQueryAccountVaultList:  [QueryKeys.accountVaultList, vaultPubkey] (validator)
// - useQueryVaultHistory:      [QueryKeys.vaultHistory, vaultTxId] (validator)
// Wallet and utxo queries:
// - useWalletSats -> useQueryWalletBalance:  [QueryKeys.walletBalance, address] (esploraUrl)
// - useRuneBalance -> useWalletAssets:       [QueryKeys.walletAssets, address] (validator)
// - useCoinUtxos:              [QueryKeys.walletCoinUtxos, address] (esploraUrl)
// MetaMask Snap routes all three through [QueryKeys.snapWalletInventory, network, identities].

export function resetVaultQueries() {
  const queryClient = getQueryClient();
  queryClient.invalidateQueries({ queryKey: [QueryKeys.accountVaultList] });
  queryClient.invalidateQueries({ queryKey: [QueryKeys.vaultHistory] });
}

export function resetWalletQueries() {
  clearSnapWalletInventoryCache();
  const queryClient = getQueryClient();
  queryClient.invalidateQueries({ queryKey: [QueryKeys.walletBalance] });
  queryClient.invalidateQueries({ queryKey: [QueryKeys.walletAssets] });
  queryClient.invalidateQueries({ queryKey: [QueryKeys.walletCoinUtxos] });
  queryClient.invalidateQueries({ queryKey: [QueryKeys.snapWalletInventory] });
}

async function scheduleVaultDataInvalidationFn(timeout = 0) {
  setTimeout(resetVaultQueries, timeout);
}

async function scheduleWalletDataInvalidationFn(timeout = 0) {
  setTimeout(async () => resetWalletQueries(), timeout);
}

export const scheduleVaultDataInvalidation = debounce(scheduleVaultDataInvalidationFn, 500);

export const scheduleWalletDataInvalidation = debounce(scheduleWalletDataInvalidationFn, 500);
